import { render, staticRenderFns } from "./PatientAlertsInfoBox.vue?vue&type=template&id=3bd28b2a&"
import script from "./PatientAlertsInfoBox.vue?vue&type=script&lang=js&"
export * from "./PatientAlertsInfoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports